module.exports = __webpack_public_path__ + "img/40.153b3fc4.153b3fc4.svg";